import React from 'react';
import { useStyletron } from 'baseui';

import { KeyValueView, CustomModal } from 'commons-ui';
import Accordian from 'commons-ui/src/components/keyValueView/Accordian';
import useUserStats from './useUserStats';
import OpponentsDetails from './opponentsDetails';

const UserStats = () => {
	const { opponentsDetailsIsCollapsed, setOpponentsDetailsIsCollapsed, keyConfig, keyValueLayout } = useUserStats();
	const [css] = useStyletron();

	const opponentsDetailsLabel = <div className={css({ fontWeight: 'bold', padding: '12px 0px' })}>User Opponents Details</div>;

	return (
		<>
			<KeyValueView keyConfig={keyConfig} keyValueLayout={keyValueLayout} />
			<Accordian
				label={opponentsDetailsLabel}
				panelKey='unnamedPanel'
				isCollapsed={opponentsDetailsIsCollapsed}
				setIsCollapsed={setOpponentsDetailsIsCollapsed}>
				<OpponentsDetails isCollapsed={setOpponentsDetailsIsCollapsed} />
			</Accordian>
			<CustomModal />
		</>
	);
};

export default UserStats;
